import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import logo from '../../static/logos/logo_2.png';
import invert_logo from '../../static/logos/logo_3.png';
import { fallDown as Menu } from 'react-burger-menu'
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import burgermenu from '../shared/images/burgermenu.svg'

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  height: 100px;
  transition: background-color 0.5s ease;
  background: ${props => (props.invert ? props.theme.colors.darkBlue : props.theme.colors.white)};
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    height: 70px;
  }
`;

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  height: 100%;
  background: ${props => (props.invert ? props.theme.colors.darkBlue : props.theme.colors.white)};
  transition: background-color 0.5s ease;
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 0 2rem;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    padding: 0 1.5rem;
  }
  a {
    color: ${props => (props.invert ? props.theme.colors.greyLight : props.theme.colors.greyDark)};
    font-size: 0.8rem;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      font-size: 1.5rem;
    }
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    border-bottom: none;
  }
  a:hover {
    color: ${props => (props.invert ? props.theme.colors.white : props.theme.colors.darkBlue)};
    border-bottom: 1px solid ${props => (props.invert ? props.theme.colors.white : props.theme.colors.darkBlue)};
  }
  .bm-burger-button {
    position: relative;
    width: 30px;
    height: 26px;
    @media (min-width: ${props => props.theme.breakpoints.m}) {
      display: none;
    }
    &::before {
      content: 'Menu';
      position: absolute;
      right: 2.6rem;
      bottom: 0.1rem;
    }
  }
  .bm-burger-bars {
    background: ${props => (props.invert ? props.theme.colors.white : props.theme.colors.black)};
  }
  .bm-burger-bars-hover {
    background: ${props => (props.invert ? props.theme.colors.darkBlue : props.theme.colors.darkBlue)};
  }
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }
  .bm-cross {
    background: #bdc3c7;
  }
  .bm-menu {
    background: ${props => (props.theme.colors.white)};
    padding: 2.5em 1.5em 0;
    font-size: 2rem;
  }
  .bm-menu-wrap {
    top: 0px;
  }
  .bm-item {
    display: inline-block;
    text-align: center;
    margin: 1rem;
  }
`;

const ImageLink = styled(Link)`
    &:hover {
      border: none !important;
    }
`;

const CompanyLogo = styled.div`
  img {
    width: auto;
    maxHeight: 50px;
  }
`;

const StyledDesktopNav = styled.nav`
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-end;
  display: flex;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    display: none;
  }
  padding-top: 2rem;
  ul {
    list-style-type: none;
    float: right;
  }
  li {
    float: left;
    margin: 0 0 0 25px;
  }
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      burgerMenuIsOpen: false
    }
  }
  render() {
    const { invert } = this.props;
    const logoSrc = invert ? invert_logo : logo;
    return (
      <HeaderContainer invert={invert}>
        <StyledHeader invert={invert}>
          <CompanyLogo>
            <ImageLink to='/'><img alt='Bourne Digital' style={{ width: 'auto', maxHeight: 50 }} src={logoSrc} /></ImageLink>
          </CompanyLogo>
          <div id='menu-group'>
            <StyledDesktopNav>
              <ul>
                <li><Link to='/'>Home</Link></li>
                <li><Link to='#services'>Projects</Link></li>
                <li><Link to='#why-bourne'>Why Bourne</Link></li>
                <li><Link to='#team'>Team</Link></li>
                <li><Link to='#blog'>Blog</Link></li>
                <li><Link to='#footer-anchor'>Contact</Link></li>
              </ul>
            </StyledDesktopNav>
            <Menu customBurgerIcon={ <img src={burgermenu} alt="Menu icon"/> } right width={'100%'} isOpen={this.state.burgerMenuIsOpen} onStateChange={(state) => this.handleMenuStateChange(state)}>
              <Link to='/' onClick={() => this.closeMenu()}>Home</Link>
              <Link to='#services' onClick={() => this.closeMenu()}>Projects</Link>
              <Link to='#why-bourne' onClick={() => this.closeMenu()}>Why Bourne</Link>
              <Link to='#team' onClick={() => this.closeMenu()}>Team</Link>
              <Link className="menu-item" to='#blog' onClick={() => this.closeMenu()}>Blog</Link>
              <Link to='#footer-anchor' onClick={() => this.closeMenu()}>Contact</Link>
            </Menu>
          </div>
        </StyledHeader>
      </HeaderContainer>
    );
  }

  closeMenu() {
    this.setState({ burgerMenuIsOpen: false })
  }

  toggleMenu() {
    this.setState({ burgerMenuIsOpen: !this.state.burgerMenuIsOpen })
  }

  handleMenuStateChange(state) {
    this.setState({ burgerMenuIsOpen: state.isOpen })
  }
}

export default Header;

Header.propTypes = {
  invert: PropTypes.bool,
};

Header.defaultProps = {
  invert: false,
};
